import {
  FORCED_EXPERIMENT_QSP,
  FORCED_EXPERIMENTS_QSP,
} from 'utils/queryParamHelpers';

/** The return value of this is an array formatted like this:
 *  [ { experimentKey: fullstack_address_autocomplete, variantKey: phone_first }, { experimentKey: fullstack_email_commitment, variantKey: hide_email} ]
 */
export default function getForcedExperimentsFromQueryParams() {
  /** We accept both 'forced_experiments' and 'forced_experiment' as it can
   * be tricky to remember which to use. */
  const forcedVariationsString =
    FORCED_EXPERIMENTS_QSP || FORCED_EXPERIMENT_QSP;

  if (!forcedVariationsString) {
    return [];
  }

  const splitExperimentWithVariants = forcedVariationsString.split(';');
  const experimentsWithVariants = [];

  splitExperimentWithVariants.forEach(exp => {
    const experimentKey = exp.split(',')[0];
    const variantKey = exp.split(',')[1];

    if (experimentKey && variantKey) {
      experimentsWithVariants.push({ experimentKey, variantKey });
    }
  });

  return experimentsWithVariants;
}
